import { render } from "./YearPicker.vue?vue&type=template&id=535a5d70"
import script from "./YearPicker.vue?vue&type=script&lang=ts"
export * from "./YearPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script